import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getStaticUrl } from "js/config";
import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import Analytics from "js/analytics";
import { Button } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";

import { DialogBody, DialogTitle, WorkspaceSelect } from "./components/DialogComponents";

function TrialPausedDialogForMember(props: { onClose: () => void, lockWorkspace: boolean }) {
    const { onClose, lockWorkspace } = props;
    const { t } = useTranslation();

    useEffect(() => {
        Analytics.Dunning.TrialPausedDialogForMemberOpened();
    }, []);

    const handleSwitchWorkspace = () => {
        Analytics.Dunning.TrialPausedDialogForMemberSwitchWorkspaceClicked();
        onClose();
    };

    const handleCreateWorkspace = () => {
        Analytics.Dunning.TrialPausedDialogForMemberCreateWorkspaceClicked();
        onClose();
    };

    const handleClose = () => {
        Analytics.Dunning.TrialPausedDialogForMemberCloseClicked();
        onClose();
    };

    return (
        <BeautifulDialog preventClose>
            <DialogBody>
                <DialogTitle>
                    <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-checkout-logo.svg")} />
                    <Gap10 />
                    {lockWorkspace && <>
                        <div>{t("The workspace is locked")}</div>
                        <p>{t("We couldn't process your payment. Ask your workspace owner to update the payment method to restore access, or continue in another workspace.")}</p>
                    </>}
                    {!lockWorkspace && <>
                        <div>{t("Your trial is on hold")}</div>
                        <p>{t("We couldn't process your payment. Ask your workspace owner to update the payment method.")}</p>
                    </>}
                </DialogTitle>
                {lockWorkspace && <WorkspaceSelect
                    onSwitchWorkspace={handleSwitchWorkspace}
                    onCreateWorkspace={handleCreateWorkspace}
                />}
                {!lockWorkspace && <Button onClick={handleClose} large color={themeColors.lightGray} style={{ color: "#666" }}>
                    {t("Close")}
                </Button>}
            </DialogBody>
        </BeautifulDialog>
    );
}

export default TrialPausedDialogForMember;
